import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UserQueryKeys } from '@enums/react-query-keys';
import { User } from '@interfaces/models/user';
import UserService from '@services/user-service';

type UpdateEmailPreferencesPayload = {
  isSubscribedToNewsletter: boolean;
  hasLegitInterestBuyer: boolean;
  hasLegitInterestSeller: boolean;
};

const useUpdateEmailPreferences = (userId: User['id']) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpdateEmailPreferencesPayload) => UserService.updateEmailPreferences(userId, payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [UserQueryKeys.USER] }),
  });
};

export default useUpdateEmailPreferences;
